import {
  ChangeDetectionStrategy,
  Component, Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import * as _ from "lodash";

interface ItemsList {
  list: any[],
  displayKey: string
}

require('./bringoz-items-link-list.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-items-link-list',
  templateUrl: './bringoz-items-link-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozItemsLinkListComponent implements OnInit, OnChanges {
  @Input() state: string;
  @Input() permission: string;
  @Input() ids: string[];
  @Input() items: any[];
  @Input() maxDisplay: number;
  @Input() textEllipsis: boolean = false;

  public viewItems: { id: string, name?: string, fullName?: string }[];
  public extraItems: { id: string, name?: string, fullName?: string }[];

  constructor(@Inject("commonsDialogService") private commonsDialogService) {
  }

  ngOnInit() {
    if (!this.maxDisplay) {
      this.maxDisplay = 1;
    }

    this._initData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ids && !changes.ids.isFirstChange() ||
      changes.items && !changes.items.isFirstChange() ||
      changes.objectsList && !changes.objectsList.isFirstChange()) {
      this._initData();
    }
  }

  onOpenDialog(event) {
    this.commonsDialogService.displayEntityLinksList(this.state, this.items, this.permission, event);
  }

  private _initData() {

    this.viewItems = [];
    this.extraItems = [];

    if (this.ids) {
      this.items = this.ids.map(id => {
        return {
          id: id
        }
      })
    }

    if (_.get(this.items, 'length')) {

      this.viewItems = this.maxDisplay ? _.filter(this.items, (item, index: number) => {
        return index < this.maxDisplay;
      }) : this.items;

      this.extraItems = this.items.slice(this.maxDisplay);

    }
  }

}
